/**
 * mobiscroll(v5) 전역 기본값 — 전 사이트 공통. app.js 가 로드 즉시 applyDefaults() 를 부른다.
 *
 * 달력 머리에 '오늘' 버튼을 단다. 내장 [mbsc-calendar-today] 는 단일 선택 달력에서 오늘을 **선택**한다
 * (범위 선택 달력은 오늘로 이동만). 호출부는 거의 다 `buttons: []` 를 직접 넘기므로 버튼 옵션으로는
 * 전역 적용이 안 되고, 머리(renderCalendarHeader) 는 아무도 안 넘겨 전역값이 먹는다.
 *
 * ⚠ 머리를 직접 넘길 때 **nav 는 기본머리와 같은 클래스를 달아야 한다** (NAV 상수).
 *   mobiscroll 기본머리는 nav 를 `mbsc-flex mbsc-flex-1-1 mbsc-calendar-title-wrapper` 로 깐다.
 *   이 클래스가 없으면 nav 가 flex 컨테이너가 아니어서 ① 화살표가 제목에 붙어 왼쪽에 몰리고
 *   ② pages>1 달력은 달마다 하나씩 붙는 제목(mbsc-flex-1-1)이 안 퍼져 년월이 통째로 왼쪽에 뭉친다.
 *
 * ⚠ renderCalendarHeader 는 **함수**여야 한다 — mobiscroll 이 호출해서 문자열을 받는다.
 *   문자열을 그대로 넘기면 달력 생성이 TypeError 로 죽는다. 그래서 아래 HEADER_* 는 전부 함수다.
 *
 * ⚠ 내장 '오늘'은 값만 바꾸고 onCellClick 을 태우지 않으며 min/max 도 보지 않는다.
 *   날짜 칸 클릭(onCellClick)으로 값을 반영하는 달력은 둘 중 하나를 한다.
 *     · 연결한다 — onToday($달력감싼요소, date => 칸 클릭과 같은 반영)   (발주 작업일)
 *     · 뺀다     — renderCalendarHeader: $j.Common.Mobiscroll.HEADER_PLAIN
 *   오늘을 고를 수 없는 달력(min 이 내일 이후)은 뺀다.
 */
const NAV = '<div mbsc-calendar-nav class="mbsc-flex mbsc-flex-1-1 mbsc-calendar-title-wrapper"></div>';
const PREV = '<button mbsc-calendar-prev></button>';
const NEXT = '<button mbsc-calendar-next></button>';
const TODAY = '<button mbsc-calendar-today></button>';
// pages>1 달력은 이전 버튼을 왼쪽 끝으로 뺀다 (기본머리가 multi 일 때 하는 것과 같다)
const PREV_MULTI = '<button mbsc-calendar-prev class="mbsc-calendar-button-prev-multi"></button>';

export default class Mobiscroll {
    /** 오늘 없는 머리 — 칸 클릭으로 값을 반영하는 달력용 */
    static HEADER_PLAIN = () => NAV + PREV + NEXT;
    /** 여러 달을 한 번에 보이는 달력(pages>1)용 — 기본값 대신 이걸 넘긴다 */
    static HEADER_TODAY_MULTI = () => NAV + PREV_MULTI + TODAY + NEXT;

    /**
     * 내장 '오늘' 버튼을 눌렀을 때 fn(오늘) 을 부른다. 달력이 오늘을 선택한 다음 틱에 돈다.
     * onChange 로 받지 않는 이유 — 칸 클릭·첫 표시와 구분이 안 돼 반영이 두 번 되거나 엉뚱할 때 된다.
     * @param $scope 달력을 감싼 요소(jQuery). 같은 요소에 다시 걸면 교체된다
     */
    static onToday($scope, fn) {
        $scope.off('click.mbscToday').on('click.mbscToday', '.mbsc-calendar-button-today', () => {
            setTimeout(() => fn(new Date()), 0);
        });
    }

    static applyDefaults() {
        if (typeof mobiscroll === 'undefined' || !mobiscroll.setOptions) return;
        mobiscroll.setOptions({ renderCalendarHeader: () => NAV + PREV + TODAY + NEXT });
    }
}
